export function ConnectGate({ children }) {
  // Novex retiré. Toutes les données proviennent de sources publiques ; on affiche toujours le contenu.
  return children;
}
